import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import NotificationService from '../../../core/services/NotificationService';

class WhitelabelConfigAuthenticationOptionsService {
  fetch = new FetchService();
  submit = new FetchService();

  constructor() {
    extendObservable(this, {
      apps: [],
      whitelabelConfigId: null,
    });
  }

  init = action((whitelabelConfigId) => {
    this.whitelabelConfigId = whitelabelConfigId;
    this.apps = [];
    this.load();
  });

  load = action(() => {
    this.fetch
      .fetch({
        url: `/whitelabel-configs/${this.whitelabelConfigId}`,
      })
      .then(() => {
        if (this.fetch.data) {
          this.apps = ['STUDENT', 'KIDS', 'PARTNER'].map((appType) => {
            const distribution = (this.fetch.data.authenticationOptions || []).find((d) => d.app === appType);
            if (distribution) {
              return distribution;
            }
            return {
              app: appType,
              ssoOnly: false,
            };
          });
        } else {
          this.apps = [];
        }
      });
  });

  updateAppOption = action((options) => {
    this.submit
      .fetch({
        url: `/whitelabel-configs/${this.whitelabelConfigId}/auth/${options.app}`,
        method: 'patch',
        body: {
          ssoOnly: options.ssoOnly,
          redirectUrl: options.ssoOnly ? options.redirectUrl : null,
        },
      })
      .then(() => {
        if (this.submit.data) {
          this.load();
          NotificationService.addNotification('Authentication options updated', 'success');
        } else {
          NotificationService.addNotification('Error to update authentication options', 'error');
        }
      });
  });
}

const whitelabelConfigAuthenticationOptionsService = new WhitelabelConfigAuthenticationOptionsService();
export default whitelabelConfigAuthenticationOptionsService;
